"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KSVFixture = void 0;
class KSVFixture {
    constructor(data) {
        var _a, _b, _c, _d, _e, _f;
        this.id = (_a = data.id) !== null && _a !== void 0 ? _a : null;
        this.date = (_b = data.date) !== null && _b !== void 0 ? _b : null;
        this.endedAt = (_c = data.endedAt) !== null && _c !== void 0 ? _c : null;
        this.isLive = (_d = data.smbIsLive) !== null && _d !== void 0 ? _d : false;
        this.contestName = (_e = data.smbMatchday.smbContest.smbContestName) !== null && _e !== void 0 ? _e : false;
        this.matchday = (_f = data.smbMatchday.smbMatchdayNumber) !== null && _f !== void 0 ? _f : null;
        this.homeClub = {
            name: data.smbHomeMatchClubData.smbClub.smbNameFull,
            nameShort: data.smbHomeMatchClubData.smbClub.smbNameShort,
            logo: data.smbHomeMatchClubData.smbClub.smbLogo,
            score: data.smbHomeMatchClubData.smbScore
        };
        this.awayClub = {
            name: data.smbGuestMatchClubData.smbClub.smbNameFull,
            nameShort: data.smbGuestMatchClubData.smbClub.smbNameShort,
            logo: data.smbGuestMatchClubData.smbClub.smbLogo,
            score: data.smbGuestMatchClubData.smbScore
        };
    }
    static fromData(data) {
        return new KSVFixture(Object.assign(Object.assign({}, data), { date: data.smbDate ? new Date(data.smbDate) : null, endedAt: data.smbEndedAt ? new Date(data.smbEndedAt) : null }));
    }
}
exports.KSVFixture = KSVFixture;
